import axios from "axios";

console.log(process.env);

//SERVER BACKEND
const serverUrl =
  process.env.NODE_ENV === "production"
    ? process.env.REACT_APP_SERVER_URL
    : "http://localhost:5000/api";

// "https://ih-finalproject.herokuapp.com/api"

const createHeaders = () => {
  return {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  };
};

const actions = {
  getUser: async () => {
    return await axios.get(`${serverUrl}/get-user`, createHeaders());
  },

  getMessages: async () => {
    let messages = await axios.get(`${serverUrl}/get-messages`);
    return messages.data;
  },

  getMyMessages: async () => {
    let messages = await axios.get(
      `${serverUrl}/get-my-messages`,
      createHeaders()
    );
    console.log(messages);
    return messages.data;
  },

  getMyOrders: async () => {
    let orders = await axios.get(
      `${serverUrl}/get-my-orders`,
      createHeaders()
    );
    console.log(orders);
    return orders.data;
  },

  addMessage: async ({ message }) => {
    return await axios.post(
      `${serverUrl}/add-message`,
      { message },
      createHeaders()
    );
  },

  logIn: async ({ profileObj }) => {
    let res = await axios.post(`${serverUrl}/logMeIn`, profileObj);
    console.log(res.data, '?')
    localStorage.setItem("token", res.data.token);
    return res.data.user;
  },

  getMargs: async () => {
    return axios.get(`${serverUrl}/margaritas`);
  },
  getBottle: async () => {
    return axios.get(`${serverUrl}/getBottle`);
  },
  getFood: async () => {
    return axios.get(`${serverUrl}/foodLocal`);
  },

  getLocation: async () => {
    return axios.get(`${serverUrl}/googleUser`);
  },

  checkout: async (cart) => {
    return axios.post(`${serverUrl}/create-checkout-session?cart=${JSON.stringify(cart)}`)
  }

};


export default actions;

// //DELIVERY TRACKER QUOTE
  // getADelivery: async (deliveryQuote) => {
  //   return await axios.post(
  //     `${serverUrl}/getDelivery`,
  //     deliveryQuote,
  //     createHeaders()
  //   );
  // },

  // //DELIVERY TRACKER ORDER
  // getADeliveryOrder: async (deliveryOrder) => {
  //   return await axios.post(
  //     `${serverUrl}/getDeliveryOrder`,
  //     deliveryOrder,
  //     createHeaders()
  //   );
  // },

  // // DELIVERY TRACKER NEW ORDER DETAILS
  // getTheDeliveryDetails: async (deliveryDetails) => {
  //   return await axios.post(
  //     `${serverUrl}/getDeliveryDetails`,
  //     deliveryDetails,
  //     createHeaders()
  //   );
  // },

  // //DELIVERY TRACKER ROBO ORDER
  // getRobotDelivery: async (deliveryRobo) => {
  //   return await axios.post(
  //     `${serverUrl}/getDelivery`,
  //     deliveryRobo,
  //     createHeaders()
  //   );
  // },